import { render, staticRenderFns } from "./goodDetail.vue?vue&type=template&id=02c98654&scoped=true"
import script from "./goodDetail.vue?vue&type=script&lang=js"
export * from "./goodDetail.vue?vue&type=script&lang=js"
import style0 from "./goodDetail.vue?vue&type=style&index=0&id=02c98654&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c98654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02c98654')) {
      api.createRecord('02c98654', component.options)
    } else {
      api.reload('02c98654', component.options)
    }
    module.hot.accept("./goodDetail.vue?vue&type=template&id=02c98654&scoped=true", function () {
      api.rerender('02c98654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/good/goodDetail.vue"
export default component.exports